export default ".anatomy-selector-field {\n  width: 100%;\n}\n";